<h1 mat-dialog-title="">User Role</h1>
<div mat-dialog-content>
    <p>{{ data.email }}</p>
    <form>
        <mat-form-field appearance="fill">
            <mat-label>Role</mat-label>
            <mat-select [formControl]="roleControl">
                @for (role of roles; track role) {
                    <mat-option [value]="role.id">{{ role.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button mat-stroked-button color="primary" (click)="save()">Save</button>
</div>
